import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-produk-add-skoring',
  templateUrl: './produk-add-skoring.component.html',
  styleUrls: ['./produk-add-skoring.component.css']
})
export class ProdukAddSkoringComponent implements OnInit {

  @Output() goNext = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  umumSkor: boolean = true;
  load: boolean = false;
  ten: any = {};
  tes: any = '';
  parameter_skoring: any = [];
  kategori_nilai_skor: any = {};
  matrix_app_new: any = {};
  matrix_app_ro: any = {};
  new_deb_non_cbi: any = [];
  ro_non_cbi: any = [];
  max_approval_plafon: any = [];

  dataUser: any = {};
  du: any = [];

  fatal_dpd: number;
  fatal_tunggakan: number;



 constructor(
     public api: ApiService,
     public util: UtilService,
     public activatedRoute: ActivatedRoute,
     public router: Router,
   ) {
 
   }

  ngOnInit(): void {
    this.getForm();
    this.getUserApproval();
  }

  back(){
    this.goBack.emit();
  }

  next(){
    this.goNext.emit();
  }

  getUserApproval() {
    this.load = true;
    this.api.get('data/master/users-client')
      .subscribe((data) => {
        this.dataUser = data;
        if (this.dataUser.error == 0) {
          this.load = false;
          this.du = this.dataUser.data;
        } else {
          this.load = false;
          this.util.showToast(this.dataUser.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  getForm() {
    this.load = true;
    this.api.get('backoffice/master/product/form-scoring')
      .subscribe((data) => {
        this.ten = data;
        if (this.ten.error == 0) {
          this.load = false;
          if (this.ten.data?.parameter_skoring) {
            this.parameter_skoring = this.ten.data.parameter_skoring.map((grp: any) => ({
              ...grp,
              checked: true,
              total_persentase: 0,
              total_final_skor: 0,
              parameters: grp.parameters.map((p: any) => ({
                ...p,
                checked: true,
                nilai: [...p.nilai]   // bikin array baru supaya tidak shared
              }))
            }));
          }

          if (this.ten.data?.kategori_nilai_skor) {
            this.kategori_nilai_skor = this.ten.data.kategori_nilai_skor;
          }

          if (this.ten.data?.matrix_approval?.new_deb_cbi) {
            this.matrix_app_new = this.ten.data.matrix_approval?.new_deb_cbi;
          }

          if (this.ten.data?.matrix_approval?.ro) {
            this.matrix_app_ro = this.ten.data.matrix_approval?.ro;
          }

          if (this.ten.data?.matrix_approval?.new_deb_non_cbi) {
            this.new_deb_non_cbi = this.ten.data.matrix_approval?.new_deb_non_cbi;
          }

          if (this.ten.data?.matrix_approval?.ro_non_cbi) {
            this.ro_non_cbi = this.ten.data.matrix_approval?.ro_non_cbi;
          }

          if (this.ten.data?.max_approval_plafon) {
            this.max_approval_plafon = this.ten.data.max_approval_plafon;
          }

          
 
        } else {
          this.load = false;
          this.util.showToast(this.ten.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  trackByIndex(index: number, item: any) {
    return index;
  }

onNilaiInput(event: any, param: any, index: number, group: any) {
  let value: string = event.target.value;

  // Ambil hanya digit pertama (kalau lebih dari 1 karakter)
  if (value && value.length > 1) {
    value = value.charAt(0);
  }

  // Validasi angka 0 - 5
  if (!/^[0-5]$/.test(value)) {
    this.util.showToast('Hanya boleh angka 0 sampai 5', 'danger', 'bottom');
    value = '';
  }

  // Cek duplikat dalam array nilai
  if (value !== '' && param.nilai.some((v: any, i: number) => i !== index && v == value)) {
    this.util.showToast('Angka Tidak Boleh Sama', 'danger', 'bottom');
    value = '';
  }

  // Set kembali ke model & input element
  param.nilai[index] = value;
  event.target.value = value;
  this.calculateFinalSkor(param, group);
}

validatePercentageGlobal(event: any, row: any) {
  const value = Number(event.target.value);

  if (value > 100) {
    // Paksa nilai pada model dan tampilan menjadi 100
    row.persentase = 100;
    event.target.value = '100';
  }
}

onGroupCheckChange(group: any) {
  if (!group.checked) {
    // Reset semua nilai input di dalam grup ini
    group.parameters.forEach((param: any) => {
      param.persentase = null;
      if (Array.isArray(param.nilai)) {
        // Buat array baru berisi string kosong dengan panjang yang sama
        param.nilai = Array(param.nilai.length).fill('');
      }
      // Hitung ulang skor akhir untuk parameter ini (akan menjadi 0)
      this.calculateFinalSkor(param, group);
    });

    // Hitung ulang total persentase untuk grup ini
    this.calculateTotalPersentase(group);
  }
}

onParameterCheckChange(param: any, group: any) {
  if (!param.checked) {
    // Reset nilai input
    param.persentase = null;
    if (Array.isArray(param.nilai)) {
      param.nilai = Array(param.nilai.length).fill('');
    }

    // Hitung ulang skor dan total
    this.calculateFinalSkor(param, group);
    this.calculateTotalPersentase(group);
  }
}

validatePersentase(param: any, group: any) {
  // Abaikan jika input kosong
  if (param.persentase !== null && param.persentase !== undefined && param.persentase !== '') {
    const value = Number(param.persentase);
    if (value > 100) {
      this.util.showToast('Persentase tidak boleh lebih dari 100.', 'danger', 'bottom');
      param.persentase = null;
    } else if (value < 0) {
      this.util.showToast('Persentase tidak boleh kurang dari 0.', 'danger', 'bottom');
      param.persentase = null;
    }
  }
  this.calculateFinalSkor(param, group);
  this.calculateTotalPersentase(group);
}

calculateTotalPersentase(group: any) {
  if (!group || !Array.isArray(group.parameters)) {
    return;
  }
  group.total_persentase = group.parameters.reduce((acc: number, param: any) => {
    const num = Number(param.persentase);
    return acc + (isNaN(num) ? 0 : num);
  }, 0);
}

calculateTotalFinalSkor(group: any) {
  if (!group || !Array.isArray(group.parameters)) {
    return;
  }
  group.total_final_skor = group.parameters.reduce((acc: number, param: any) => {
    const num = Number(param.final_skor);
    return acc + (isNaN(num) ? 0 : num);
  }, 0);
}

calculateFinalSkor(param: any, group: any) {
  if (!Array.isArray(param.nilai) || param.persentase === null || param.persentase === undefined || param.persentase === '') {
    param.final_skor = 0;
    this.calculateTotalFinalSkor(group);
    return;
  }

  // Ambil nilai tertinggi yang valid (angka) dari array 'nilai'
  const highestNilai = param.nilai.reduce((max: number, val: any) => {
    const num = Number(val);
    return isNaN(num) ? max : Math.max(max, num);
  }, 0);

  const persentase = Number(param.persentase);

  // Hitung skor akhir: (nilai tertinggi * persentase)
  // dan pastikan hasilnya tidak NaN
  param.final_skor = !isNaN(persentase) ? (highestNilai * persentase) : 0;
  this.calculateTotalFinalSkor(group);
}





}
